import { useAppSelector } from "@app/hooks";
import { useMsal } from "@azure/msal-react";
import { LBtn } from "@components";
import { NavItems } from "@helpers/navigation";
import { loginRequest } from "../../../authConfig";

export const CreatedAccount = (): JSX.Element => {
    const { instance } = useMsal();
    const isCheckout = useAppSelector((x) => x.globalSettings.isCheckout);

    const handleOnGoLogin = async (): Promise<void> => {
        const redirectUri = isCheckout ? NavItems.Purchase.Checkout.path : NavItems.Purchase.Pricing.path;

        await instance.loginRedirect({ ...loginRequest, redirectUri });
    };

    return (
        <div className="hero-body pt-0 is-justify-content-center">
            <div className="hero-body">
                <div className="container has-text-centered">
                    <div className="title is-2">{"You've successfully created your"}</div>
                    <div className="title is-2" role="heading">
                        {"i-Function account!"}
                    </div>
                    <div className="buttons is-centered section">
                        <LBtn type="button" onClick={handleOnGoLogin}>
                            {"Click to Login and Checkout"}
                        </LBtn>
                    </div>
                </div>
            </div>
        </div>
    );
};
